
import { ExcelMapperSettings } from "@/models/excel-mapper-settings";
import AppFileUpload from "./ExcelMapperSettingsEditUploadFile.vue";
import Vue from "vue";
import { createExcelMapperWrapper } from "@/utils/excel-mapper/excel-mapper-wrapper";

export default Vue.extend({
	data(){
		return {
			worksheet: createExcelMapperWrapper(),
			isProcessing: false,
			progress: 0
		};
	},
	props: {
		settings: {
			type: Object as ()=>ExcelMapperSettings,
			required: true
		}
	},
	computed: {
		isValid():boolean {
			if (this.settings.Settings.Cols.length == 0) return false;
			return this.worksheet.hasSheet;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (!this.worksheet.hasSheet) return;
			let sheet = this.worksheet.getSheet();
			if (!sheet) return;
			if (this.isProcessing) return;
			this.isProcessing = true;
			try{
				console.log("Started converter");
				let converter  = this.settings.Settings.createConverter();
				let newWorkBook = await converter.start(sheet, (progress:number)=>this.progress = progress);
				let result = await newWorkBook.xlsx.writeBuffer();
				let file = new Blob([result], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
				this.$emit("file", file);
			}catch(err){
				throw err;
			}finally{
				this.isProcessing = false;
			}
		},
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.excel-mapper"
	}
});
